<template>
  <el-menu
    default-active="2"
    class="el-menu-vertical-demo menu-height"
    @open="handleOpen"
    @close="handleClose"
    text-color="#000"
    router
    active-text-color="#409eff"
    :default-openeds="['1']"
  >
    <el-submenu index="1">
      <template slot="title">
        <i class="el-icon-setting"></i>
        <span>Управление</span>
      </template>

      <el-menu-item index="/organization">Данные организации</el-menu-item>
      <el-menu-item index="/contacts">Контакты</el-menu-item>
      <el-menu-item index="/credentials">Учетные данные</el-menu-item>
      <el-menu-item index="/settings">Настройки ЛК</el-menu-item>
      <el-menu-item index="/accounts">Лицевые счета</el-menu-item>

      <el-menu-item index="/requests" v-if="getOrganizationInfo.userRequestTarget !== 3">
        <el-badge :hidden="!hasUnreadRequestsOrComments" is-dot class="item">
          Заявки
        </el-badge>
      </el-menu-item>
    </el-submenu>
    <el-submenu index="3" v-if="getOrganizationInfo.userRequestTarget !== 3">
      <template slot="title">
        <i class="el-icon-message"></i>
        <span>Сообщения</span>
      </template>
      <el-menu-item index="/alerts">Опубликованные</el-menu-item>
      <el-menu-item index="/alerts/moderate">На модерации</el-menu-item>
      <el-menu-item index="/alerts/declined">Отклоненные </el-menu-item>
    </el-submenu>
    <el-submenu index="2" v-if="getOrganizationInfo.hasSite">
      <template slot="title">
        <i class="el-icon-menu"></i>
        <span>Разделы сайта</span>
      </template>
      <el-menu-item index="/mainpage">Главная</el-menu-item>
      <el-menu-item index="/about">О нас</el-menu-item>
      <el-menu-item index="/news">Новости</el-menu-item>
      <el-menu-item index="/announcement">Объявления</el-menu-item>
      <el-menu-item index="/documents">Документы</el-menu-item>
      <el-menu-item index="/vacancies">Вакансии</el-menu-item>
      <el-menu-item index="/site-settings">Настройки</el-menu-item>
    </el-submenu>
  </el-menu>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  methods: {
    handleOpen(key, keyPath) {
      //console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      //console.log(key, keyPath);
    }
  },
  computed: {
    ...mapGetters(["getOrganizationInfo", "hasUnreadRequestsOrComments"])
  },
  mounted() {
    try {
      if (this.getOrganizationInfo.hasSite === null) {
        this.$store.dispatch("organization");
      }
      this.$store.dispatch("fetchUnreadRequests");
    } catch (e) {
      this.$ErrorsMod(e);
    }
  }
};
</script>

<style scoped>
::v-deep .el-badge__content.el-badge__content--undefined.is-fixed.is-dot {
  top: 1em;
  right: -0.5em;
}
.menu-height {
  height: calc(100vh - 60px);
  overflow: hidden auto;
}
</style>
